export default __webpack_public_path__ + "static/media/pich-bruise.1de3ecf9.jpg";